/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Mapping all the visuals and filters in here
 */
const VISUAL_MAPPER = {
  summaryVisualFilter: ['SD-1', 'SD-2', 'TVT-6', 'SDH'],
  paceVisualFilter: ['SD-3'],
  dashboardVisualFilter: ['PD-1', 'PD-3', 'PD-2', 'TVT-6'],
  webClicksTimeVisualFilter: ['TVT-6', 'WCT-1', 'CWCT-1', 'WWCT-1'],
  webClicksTimePaceVisualFilter: ['WCT-2', 'CWCT-2'],
  webClicksSegmentVisualFilter: ['WCS-1', 'CWCS-1', 'WWCS-1'],
  webClicksSegmentPaceVisualFilter: ['WCS-2', 'CWCS-2'],
  webClicksHotelVisualFilter: ['WCH-1', 'CWCH-1', 'WWCH-1'],
  webClicksHotelPaceVisualFilter: ['WCH-2', 'CWCH-2'],
  webClicksUtmVisualFilter: ['WCU-1', 'WCU-2', 'CWCU-1', 'CWCU-2', 'WWCU-1'],
  reginalMapFilter: ['RB-1', 'RBT-1'],
  paceTimeRevenueFilter: [
    'TVT-6',
    'PVTC-1',
    'PVT-3',
    'PVT-4',
    'PVTCL-1',
    'PVTL-3',
    'PVTL-4',
    'PDH-1',
  ],
  paceCancellationFilter: ['PCC-1'],
  paceOccupiedRoomFilter: ['PVTCL-1', 'PVTC-1', 'PVT-2', 'PVTL-2'],
  paceSegmentVisualFilter: [
    'PVS-1',
    'PVS-2',
    'PVS-3',
    'PVS-4',
    'PVSL-1',
    'PVSL-2',
    'PVSL-3',
    'PVSL-4',
    'PVSLC-1',
    'PVSLC-2',
    'PVSLC-3',
  ],
  paceHotelVisualFilter: [
    'PVHFLC-1',
    'PVHFLC-2',
    'PVHL-4',
    'PVHL-3',
    'PVHFL-1',
    'PVHFL-2',
    'PVHF-1',
    'PVHF-2',
    'PVH-3',
    'PVH-4',
    'WTVHT-3',
    'WTVHT-4',
    'WTVHT-5',
    'TVHT-5',
    'TVHT-3',
    'TVHT-4',
  ],
  trendHotelNormalizedFilterList: [
    'TVH-1',
    'TVH-2',
    'TVH-6',
    'CTVH-1',
    'CTVH-2',
    'CTVH-4',
    'CTVHF-1',
    'CTVHF-2',
    'WTVHF-1',
    'WTVHF-2',
    'WTVH-6',
    'TVHF-1',
    'TVHF-2',
    'CTVHT-1',
    'CTVHT-2',
    'CTVHT-4',
    'WTVHT-1',
    'WTVHT-2',
    'WTVHT-6',
  ],
  trendHotelFilterList: ['TVH-3', 'TVH-4', 'TVH-5', 'TVH-3', 'WTVH-3', 'WTVH-4', 'WTVH-5'],
  trendSegmentFilterList: [
    'TVS-1',
    'TVS-2',
    'TVS-3',
    'TVS-4',
    'TVS-5',
    'TVS-6',
    'CTVS-1',
    'CTVS-2',
    'WTVS-3',
    'WTVS-5',
    'WTVS-4',
    'CTVS-4',
    'WTVS-6',
    'WTVS-1',
    'WTVS-2',
    'TVST-1',
    'TVST-2',
    'TVST-3',
    'TVST-5',
    'TVST-4',
    'TVST-6',
    'WTVST-1',
    'WTVST-2',
    'WTVST-3',
    'WTVST-4',
    'WTVST-5',
    'WTVST-6',
    'CTVST-1',
    'CTVST-2',
    'CTVST-4',
  ],
  trendTimeFilterList: [
    'TVT-1',
    'TVT-2',
    'TVT-3',
    'TVT-4',
    'TVT-5',
    'TVT-7',
    'WTVT-1',
    'WTVT-2',
    'WTVT-3',
    'WTVT-4',
    'WTVT-5',
    'WTVT-6',
    'CTVT-1',
    'CTVT-2',
    'CTVT-4',
    'TVTT-1',
    'TVTT-2',
    'TVTT-3',
    'TVTT-4',
    'TVTT-5',
    'TVTT-6',
    'CTVTT-1',
    'CTVTT-2',
    'WTVTT-3',
    'WTVTT-4',
    'WTVTT-5',
    'CTVTT-4',
    'WTVTT-6',
    'WTVTT-1',
    'WTVTT-2',
    'WTVTT-3',
    'WTVTT-4',
    'WTVTT-5',
    'WTVTT-6',
  ],
  trendTimeTabularFilterList: [
    'CTT-1',
    'CCTT-1',
    'CWTT-1',
    'CPTT-1',
    'CTTXST-1',
    'CWTTXST-1',
    'CCTTXST-1',
  ],
  trendHotelTabularFilterList: ['CTH-1', 'CCTH-1', 'CWTH-1', 'CPTH-1'],
  trendSegmentTabularFilterList: ['CTS-1', 'CCTS-1', 'CWTS-1', 'CPTS-1', 'TXS-6'],
  //
  paceTimeTabularFilterList: ['CPT-1', 'CCPT-1', 'CPLT-1', 'CCPLT-1'],
  paceHotelTabularFilterList: ['CPH-1', 'CCPH-1', 'CPLH-1', 'CCPLH-1'],
  paceSegmentTabularFilterList: ['CPS-1', 'CCPS-1', 'CPLS-1', 'CCPLS-1'],
  //
  paceTimeSegmentTabularFilterList: ['CPTS-1', 'CCPTS-1', 'CPLTS-1', 'CCPLT-1'],
  paceHotelSegmentTabularFilterList: ['CPHS-1', 'CCPHS-1', 'CPLHS-1', 'CCPLHS-1'],
  //
  paceTimeSegmentFilterList: [
    'PVTSC-1',
    'PVTSC-2',
    'PVTSC-3',
    'PVTSCL-1',
    'PVTSCL-2',
    'PVTSCL-3',
    'PVTS-1',
    'PVTS-2',
    'PVTS-3',
    'PVTS-4',
    'PVTSL-1',
    'PVTSL-2',
    'PVTSL-3',
    'PVTSL-4',
  ],
  paceHotelSegmentFilterList: [
    'PVHSC-1',
    'PVHSC-2',
    'PVHSC-3',
    'PVHSCL-1',
    'PVHSCL-2',
    'PVHSCL-3',
    'PVHS-1',
    'PVHS-2',
    'PVHS-3',
    'PVHS-4',
    'PVHSL-1',
    'PVHSL-2',
    'PVHSL-3',
    'PVHSL-4',
  ],
  //
  trendHotelSegmentFilterList: [
    'TVHS-1',
    'TVHS-2',
    'TVHS-3',
    'TVHS-4',
    'TVHS-5',
    'TVHS-6',
    'WTVHS-1',
    'WTVHS-2',
    'WTVHS-3',
    'WTVHS-4',
    'WTVHS-5',
    'WTVHS-6',
    'CTVHS-1',
    'CTVHS-2',
    'CTVHS-4',
  ],
  trendHotelSegmentTabularFilterList: ['CTHS-1', 'CCTHS-1', 'CWTHS-1'],
  ratePlanFilterList: ['PD-5'],
  consortiaFilterList: ['PD-7'],
};
//
export default VISUAL_MAPPER;
